require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-applied-visual-design-create-a-more-complex-shape-using-css-and-html.json") })
        }
      }, "path---responsive-web-design-applied-visual-design-create-a-more-complex-shape-using-css-and-html");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-applied-visual-design-create-a-more-complex-shape-using-css-and-html!./.cache/json/responsive-web-design-applied-visual-design-create-a-more-complex-shape-using-css-and-html.json
// module id = 2553
// module chunks = 231608221292675